import axios from 'axios'
import {API_URL} from '../../../../../_metronic/helpers'
import {OPEN_BUSINESS_PARAM} from '../../../auth/core/tabBusiness'
import {BUSINESS_LANDING_PATH} from '../../../auth/core/postLoginPath'
import {confirmLeavingUnsavedWork} from './unsavedWork'

/**
 * Opens a business in this tab (backend 1.0.0.747+ keeps it for this tab only; the other tabs keep theirs): asks first
 * when an invoice form is open, chooses it through auth/changeCompany (which also records it among the user's recent
 * businesses) and reloads at `to`, the current page by default. False when the user kept their work.
 */
export const switchBusiness = async (companyId: number, to?: string): Promise<boolean> => {
  if (!confirmLeavingUnsavedWork()) return false
  await axios.post(`${API_URL}/auth/changeCompany`, {compnyId: companyId})
  if (to) window.location.assign(to)
  else window.location.reload()
  return true
}

/** The address that opens `path` in a new tab, in the given business: by default its landing (a partner's workspace, else the dashboard). */
export const businessTabUrl = (companyId: number, path = BUSINESS_LANDING_PATH) =>
  `${path}${path.includes('?') ? '&' : '?'}${OPEN_BUSINESS_PARAM}=${companyId}`

/** A short name for a tab title or a chip: the panel label when the business has one, else its name. */
export const businessShortName = (name?: string | null, label?: string | null) =>
  (label || '').trim() || (name || '').trim()
